export default {
    app_name: 'Bookeraj',

    microcopy: {
        add: 'Dodaj',
        add_plus: '+ Dodaj',
        back: 'Nazad',
        ok: 'Ok',
        remove: 'Ukloni',
        next: 'Dalje',
        complete: 'Gotovo',
        close: 'Zatvori',
        continue: 'Nastavi',
        cancel: 'Otkaži',
        confirm: 'Potvrdi',
        new: 'Nov',
        save: 'Sačuvaj',
        created: 'Kreirano',
        success: 'Uspiješno',
        none: 'Nijedan',
        category: 'Kategorija',
        delete: 'Ukloni',
        edit: 'Uredi',
        accept: 'Prihvati',
        decline: 'Poništi',
        from: 'od',
        to: 'do',
        extend: 'Produži',
        apply: 'Primjeni',
        show_more: 'Učitaj više',
        details: 'Detaljnije',
        show_all: 'Prikaži sve',
        select: 'Izaberi',
        view: 'Prikaži',
        all: 'Svi',
        company: 'Kompanija',
        companies: 'Kompanije',
        in: 'u',
        account: 'Nalog',
        book: 'Rezerviši',
        respond: 'Odgovori',
        open: 'Otvoren',
        check_availability: 'Provjeri dostupnost',
        by: 'od',
        reviews: 'Broj ocjena: {n}',
        view_number: 'Pregleda: {n}',
        favorites: 'Omiljeni',
        about: 'O',
        about_us: 'O nama',
        meet_the_team: 'Upoznaj tim',
        our_team: 'Naš tim',
        contact_us: 'Kontaktirajte nas',
        email: 'Email',
        phone: 'Telefon',
        go_to_profile: 'Idi na profil',
        [true]: 'Da',
        [false]: 'Ne',
        done: 'Završeno',
        description: 'Opis',
        you: 'Vi',
        invite: 'Pozovi',
        check: 'Provjeri',
        date: 'Datum',
        and: 'i',
        soldout: 'POPUNJENO',
        unavailable: 'NEDOSTUPNO',
        reset: 'Resetuj filtere',
        total_price: 'Ukupna cijena:',
        total_time: 'Ukupno vrijeme:',
        choose_time: 'Izaberi vrijeme',
        copied: 'Kopirano',
        copy: 'Kopirati',
        share: 'Podijeli',
        reload: 'Osveži',
        flexible: 'Fleksibilno',
        day: 'Dnevni',
        month: 'Mesečni',
        send_sms: 'Pošalji sms',
        key: 'Ključ',
        value: 'Vrednost',
        no_results: 'Nema rezultata',
        language: 'Jezik',
        view_details: 'Pogledaj detalje',
        preview_daily_schedule: 'Prikaži dnevni raspored',
        free_reservation: 'Slobodna rezervacija',
        hours: 'Sati',
        minutes: 'Minuti',
        protected: 'zaštićeno',
        download_pdf: 'Sačuvaj kao pdf',
        note: 'Napomena',
        note_reservation: 'Napomena za rezervaciju',
        i_want: 'Želim',
        dont_want: 'Ne želim',
        current_price: 'Trenutna cena:',
        suggested_parking: 'Preporučeno mesto za parkiranje',
        activate: 'Aktiviraj',
        admin: 'Admin',
        daily: 'Dnevni',
        weekly: 'Nedeljni',
        montly: 'Mesečni',
    },

    calendar: {
        today: 'Danas',
        slots: '1 termin | {n} termina',
    },

    general: {
        not_saved: 'Trenutne izmjene nisu sačuvane. Da li želite da ih sačuvate?',
    },

    days: {
        mon: { short: 'Pon', long: 'Ponedeljak' },
        tue: { short: 'Uto', long: 'Utorak' },
        wed: { short: 'Sre', long: 'Sreda' },
        thu: { short: 'Čet', long: 'Četvrtak' },
        fri: { short: 'Pet', long: 'Petak' },
        sat: { short: 'Sub', long: 'Subota' },
        sun: { short: 'Ned', long: 'Nedelja' },
    },

    months: {
        0: { short: 'Jan', long: 'Januar' },
        1: { short: 'Feb', long: 'Februar' },
        2: { short: 'Mar', long: 'Mart' },
        3: { short: 'Apr', long: 'April' },
        4: { short: 'Maj', long: 'Maj' },
        5: { short: 'Jun', long: 'Jun' },
        6: { short: 'Jul', long: 'Jul' },
        7: { short: 'Avg', long: 'Avgust' },
        8: { short: 'Sep', long: 'Septembar' },
        9: { short: 'Okt', long: 'Oktobar' },
        10: { short: 'Nov', long: 'Novembar' },
        11: { short: 'Dec', long: 'Decembar' },
    },

    errors: {
        common_error: 'Došlo je do greške',
        invalid_image: 'Slika nije validna',
        wait_for_upload_complete: 'Molimo vas da sačekate da se trenutno učitavanje završi',
        location_required: 'Da biste kreirali uslugu dodajte lokaciju!',
        wrong_subdomain:
            'Kompanija sa tim subdomenom nije pronađena. U slučaju da je izmijenjen subdomen pokušajte da je pronađete na bookeraj aplikaciji.',
    },
}
